import axios from 'axios';
import AuthService from './auth';

// Auth service
const authService = new AuthService();

// private interceptor
const interceptor = (config) => {
  const token = authService.getToken();
  if (token) {
    const headers = { ...config.headers };
    headers.Authorization = `Bearer ${token}`;
    return { ...config, headers };
  }
  return config;
};

// response interceptor: sempre que o backend rotacionar a sessão, ele devolve um
// JWT novo no header `Refreshed-Token`. Trocamos o token armazenado em qualquer
// resposta. É o que derruba o bloqueio de LGPD logo após a assinatura.
//
// O header vem com o prefixo `Bearer ` (ex.: `Bearer eyJ...`), assim como o
// `Authorization` do login — que é higienizado em `extractTokenFromResponse`.
// Removemos o prefixo antes de salvar; caso contrário o request interceptor
// monta `Authorization: Bearer Bearer <jwt>` e o backend responde 401.
const refreshTokenInterceptor = (response) => {
  const rawToken = response.headers['refreshed-token'];
  if (rawToken) {
    const newToken = rawToken.replace(/^Bearer\s+/i, '');
    authService.setToken(newToken);
  }
  return response;
};

// private api for cards customizations/settings
const analyzeConfigColorClient = axios.create({
  baseURL: process.env.REACT_APP_CHART_COLORS_CONFIG,
});
analyzeConfigColorClient.interceptors.request.use(interceptor);

// private api for analyze client
const analyzePrivClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
analyzePrivClient.interceptors.request.use(interceptor);

// private api for analyze client
const tensaiPrivClient = axios.create({
  baseURL: process.env.REACT_APP_TENSAI_URL,
});
tensaiPrivClient.interceptors.request.use(interceptor);
tensaiPrivClient.interceptors.response.use(refreshTokenInterceptor);

// public api for tensai client
const loginPubClient = axios.create({
  baseURL: process.env.REACT_APP_LOGIN_URL,
});

// private api for stats (TODO: temporário)
const statsPrivClient = axios.create({
  baseURL: process.env.REACT_APP_STATSML_URL,
});

// private api for docx-report-generator
const reportGeneratorPrivClient = axios.create({
  baseURL: process.env.REACT_APP_REPORT_GENERATOR,
  headers: {
    'Content-Encode': 'gzip',
  },
});
reportGeneratorPrivClient.interceptors.request.use(interceptor);

export { analyzePrivClient, tensaiPrivClient, loginPubClient, statsPrivClient, reportGeneratorPrivClient, analyzeConfigColorClient };
